import { HelmetDexteel } from "@dexteel/mesf-core";
import { RMShiftReport } from "./components/RMShiftReport";

export const RMShiftReportPage = () => {
	return (
		<>
			<HelmetDexteel title="RM Shift Report" />
			<RMShiftReport />
		</>
	);
};
